import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {CoverPagePreviewPrint} from '../../widgets/CoverPage/CovePreviewPrint';
import moment from 'moment';
import {TextInput} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import Moment from 'moment';
import {PERMISSIONS} from '../../../constants/APP_CONSTANTS';
import UserPermissionSingleton from '../../../_helpers/UserPermissionSingleton';

export default class ETextSetup extends Component {
    sendInviteEmail = () => {
        this.props.sendInviteEmail(this.props.match.params.collId);
    };

    constructor(props) {
        super(props);
        this.state = {
            studentInviteLinks: [],
            productDeliveryType: ''
        };

        this.updateSubscriptionLength = this.updateSubscriptionLength.bind(this);
    }

    static get propTypes() {
        return {
            collectionId: PropTypes.string.isRequired,
            getEtextStatuses: PropTypes.func.isRequired,
            etextStatuses: PropTypes.array.isRequired,
            sendInviteEmail: PropTypes.func.isRequired,
            subscriptionLength: PropTypes.number,
            setComponent: PropTypes.func,
            guardDirtySetActive: PropTypes.func,
            setSubscriptionLength: PropTypes.func.isRequired,
            callStudentInviteLink: PropTypes.func.isRequired
        };
    }

    componentDidMount() {
        if (typeof this.props.setComponent === 'function') {
            this.props.setComponent("EtextSetup");
        }
        // Call Student Invite Link
        this.props.callStudentInviteLink(this.props.match.params.collId)
            .then((data) => {
                this.setState({studentInviteLinks: data.data});
            })
            .catch(e => this.setState({studentInviteLink: ''}));
    }

    componentWillMount() {
        this.props.getEtextStatuses(this.props.match.params.collId);
    }

    componentWillUnmount() {
        this.props.guardDirtySetActive(false);
    }

    updateSubscriptionLength(event) {
        const re = /^[0-9\b]{1,3}$/;
        if (re.test(event.target.value)) {
            this.props.guardDirtySetActive(true);
            this.props.setSubscriptionLength(event.target.value);
        } else if (event.target.value === '') {
            this.props.guardDirtySetActive(true);
            this.props.setSubscriptionLength(0);
        }
    }

    render() {
        const coverWidth = 220;
        const coverHeight = 250;
        const {orderDetails, activeCollection, etextStatuses, bookdetails} = this.props;
        const CourseInfo = activeCollection && activeCollection.collectionCourseInformation ? activeCollection.collectionCourseInformation : {};
        const startAndEndDate = (CourseInfo.classStart ? moment(CourseInfo.classStart).format('ll') : '--') + ' - ' + (CourseInfo.classEnd ? moment(CourseInfo.classEnd).format('ll') : '--');
        const {studentInviteLinks,productDeliveryType} = this.state;

        return (<div className='etext_setup_page'>
            <div className='top_info_wrapper'>Review the eText course information as it will display to Instructors and
                Students. If you need to make changes, return to Book Details and Order Details, then Save changes. Once
                everything looks good, SEND TO eText
            </div>
            <div className="section_breaker"></div>
            <div className='two_coloumn_wrapper'>
                <div className='left'>
                    <div className="front_cover" style={{width: coverWidth, height: coverHeight}}>
                        {this.props.activeCollection.collectionId ? <CoverPagePreviewPrint
                            renderWidth={coverWidth}
                            pageTrimSize={this.props.activeCollection.pageSize}
                            collectionId={this.props.activeCollection.collectionId}
                            coverPageTextInfo={this.props.coverPageTextInfo}
                            startAndEndDate={startAndEndDate}
                            getCoverPageTextInfo={this.props.getFrontCoverPage}/> :
                            <div className="empty-cover"></div>
                        }
                    </div>
                </div>
                <div className='right'>
                    <h2>Pearson Digital Collection for {activeCollection.title ? activeCollection.title : ''}</h2>
                    <div className='book_info'>
                        <h3>{CourseInfo.courseTitle ? CourseInfo.courseTitle : '--'}</h3>
                        <h4>{bookdetails.field3 ? bookdetails.field3 : ''}</h4>
                        <h4>{startAndEndDate}</h4>
                    </div>
                </div>
            </div>
            <div className='course_info_wrapper'>
                <h2>Course Information</h2>
                <div className='info_block'>
                    <label>Course Name</label>
                    <h4>{CourseInfo.courseTitle ? CourseInfo.courseTitle : '--'}</h4>
                </div>
                <div className='info_block'>
                    <label>Course Number</label>
                    <h4>{CourseInfo.courseNo ? CourseInfo.courseNo : '--'}</h4>
                </div>
                <div className='info_block'>
                    <label>Educator</label>
                    <h4>{orderDetails.contact.instructor ? orderDetails.contact.instructor.firstName : ''} {orderDetails.contact.instructor ? orderDetails.contact.instructor.lastName : ''}</h4>
                </div>
                <div className='info_block two_coloumn'>
                    <div className='left'>
                        <label>Course Dates</label>
                        <h4>{startAndEndDate}</h4>
                    </div>
                    <div className='right'>
                        <div className="access-code-subscription">
                            <div className="subscription-input">
                                <TextInput id="spwAccessCodeId"
                                    labelText="Student subscription length"
                                    fancy={false}
                                    changeHandler={this.updateSubscriptionLength}
                                    inputState={ UserPermissionSingleton.hasPermission( PERMISSIONS.view_only_etext_student_subcription_length) ? "disabled" : "default"}
                                    value={this.props.subscriptionLength}
                                />
                                <div className="subscription-days">
                                    <label className="pe-textLabelInput__label">days</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='info_block'>
                    <label>Student Invite Link</label>
                    {
                        studentInviteLinks.length >0 ?
                            studentInviteLinks.map((inviteLink, index) => (
                                <div>
                                    <div className="invite_link_details">
                                        <label className="invite_link_span">Course Start Date : {Moment.utc(inviteLink.startDate).format("MM-DD-YYYY")}</label>
                                        <label className="invite_link_span">Course End Date : {Moment.utc(inviteLink.endDate).format("MM-DD-YYYY")}</label>
                                    </div>
                                    <h4 style={{position: "relative"}} key={index}>{inviteLink.inviteLink}</h4>
                                </div>

                            )) : <h4 style={{position: "relative"}}>Pending set-up</h4>
                    }

                </div>
            </div>
            <div className="section_breaker"></div>
            {!UserPermissionSingleton.hasPermission(PERMISSIONS.hide_etext_status_log) 
            && <div className="etext_log_wrapper">
                <h2>eText Status Log</h2>
                <div className="log_table">
                    <div className="log_row">
                        <p>Product Record sent to PDZ:</p>
                        <label>{etextStatuses['PRODUCT_CREATION']}</label>
                    </div>
                    <div className="log_row">
                        <p>PDF sent to eText Optimization:</p>
                        <label>{etextStatuses['INITIAL_CONTENT_PROCESSING']}</label>
                    </div>
                    <div className="log_row">
                        <p>eText Optimization Results:</p>
                        <label>{etextStatuses['ETEXT_OPTIMIZE_STATUS']}</label>
                    </div>
                    <div className="log_row">
                        <p>CITE TOC Manifest received:</p>
                        <label>{etextStatuses['CONTENT_PROCESS_STATUS']}</label>
                    </div>
                    <div className="log_row">
                        <label>"If you don't see a failure message from the above status, please wait to resend the
                            Collection.</label>
                    </div>
                    <div className="log_row">
                        <p>CITE TOC Manifest sent to CSG and PLA:</p>
                        <label>{etextStatuses['CONTENT_PUBLISH_MSG']}</label>
                    </div>
                    <div className="log_row">
                        <p>CSG Indexed for In-content Search:</p>
                        <label>{etextStatuses['INDEX_BUILD_COMPLETED']}</label>
                    </div>
                    <div className="log_row">
                        <p>PLA data ready for instructor Dashboard:</p>
                        <label>{etextStatuses['SEED_COMPLETED']}</label>
                    </div>
                    <div className="log_row">
                        <p>Instant Purchase Offer Created:</p>
                        <label>{etextStatuses['INSTANT_PURCHASE_OFFER']}</label>
                    </div>
                    {
                        activeCollection.accessCodeIsbn && <div className="log_row">
                            <p>Access Card Offer Created:</p>
                            <label>{etextStatuses['ACCESS_CARD_OFFER']}</label>
                        </div>
                    }
                    <div className="log_row">
                        <p>Free Trial Offer Created:</p>
                        <label>{etextStatuses['FREE_TRIAL_OFFER']}</label>
                    </div>
                    <div className="log_row">
                        <p>Course Creation Completed:</p>
                        <label>{etextStatuses['COURSE_CREATION']}</label>
                    </div>
                    <div className="log_row">
                        <p>Course Association Completed:</p>
                        <label>{etextStatuses['COURSE_ASSOCIATION']}</label>
                    </div>
                    <div className="log_row">
                        <p>Instructor Invite Email Sent:</p>
                        <label>{etextStatuses['INVITE_EMAIL']}</label>
                    </div>
                </div>

            </div>}
            {!UserPermissionSingleton.hasPermission( PERMISSIONS.hide_etext_invite_instructor) 
            && <div className="email_invite_wrapper">
                {
                    (etextStatuses['INVITE_EMAIL'].indexOf("SUCCESS") > -1) ?
                        <div> <button className="pe-btn__primary--btn_small" disabled>Email Invite to Instructor</button>
                            <p>Send to eText process is completed</p> </div> :
                        (etextStatuses['COURSE_CREATION'].indexOf("SUCCESS") > -1) ?
                            <div>
                                <button onClick={this.sendInviteEmail} className="pe-btn__primary--btn_small">Email Invite
                                    to Instructor
                                </button>
                            </div> : <div>
                                <button className="pe-btn__primary--btn_small" disabled>Email Invite to Instructor</button>
                                <p>This button will become active once the eText is ready to be shared with Instructor</p>
                            </div>
                }
            </div>}
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ETextSetup.js